import { AgreementFields } from "../components/shared/AgreementDataRow";

// Field Grouping Utils
export const groupFieldsByGroup = (
  fields: AgreementFields,
): Record<string, AgreementFields> => {
  return fields.reduce(
    (groups, field) => {
      const groupKey = field.group || "default";
      if (!groups[groupKey]) {
        groups[groupKey] = [];
      }
      groups[groupKey] = [...groups[groupKey], field];
      return groups;
    },
    {} as Record<string, AgreementFields>,
  );
};

export const shouldShowGroupTitle = (groupKey: string): boolean => {
  return groupKey !== "default";
};

export const getGroupTitleKey = (groupKey: string): string => {
  return shouldShowGroupTitle(groupKey) ? `agreements.groups.${groupKey}` : "";
};

// Attachment Grouping Utils
export interface FileMetadata {
  path: string;
  size: string;
  confirmed_at?: string | null;
}

export interface AttachmentGroup {
  key: string;
  files: FileMetadata[];
  title: string;
}

export type Attachments = FileMetadata[] | AttachmentGroup[];

export const isGroupedAttachments = (
  attachments: Attachments,
): attachments is AttachmentGroup[] => {
  return (
    attachments.length > 0 &&
    typeof attachments[0] === "object" &&
    "files" in attachments[0]
  );
};

export const hasAnyFiles = (attachments: Attachments): boolean => {
  if (!attachments || attachments.length === 0) {
    return false;
  }

  if (isGroupedAttachments(attachments)) {
    return attachments.some((group) => group.files.length > 0);
  }

  return attachments.length > 0;
};
